// [CurveBeam] - [BoneVue]

import { ServicesManager } from '@ohif/core';
import { loadS3DicomFile } from './loadS3DicomFile';
import { DicomSr } from '../models/bmd.model';

export async function loadSegmentation(
  servicesManager: ServicesManager,
  segmentationUrl: string,
  seriesUID: string,
): Promise<DicomSr[]> {
  const displaySetInstanceUID = await loadS3DicomFile(servicesManager, segmentationUrl);
  const dicomSrMapping: DicomSr = {
    sourceSeriesUID: seriesUID,
    displaySetInstanceUID,
  };
  console.log('Segmentation loaded', { dicomSrMapping });
  return [dicomSrMapping];
}
